exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login.white-label .wrapper-main{height:100%;background:url(" + require("./background.jpg") + ") no-repeat 50% fixed;background-size:cover}.login.white-label .wrapper-main .right-side{max-width:250px}.login.white-label .wrapper-main .right-side img{width:250px;height:auto;margin-top:80px;margin-bottom:20px}.login.white-label .wrapper-main h5{color:#545454;font-size:17px;text-align:center;font-weight:700;margin-bottom:20px;margin-top:30px}.login.white-label .wrapper-main p{color:#898989;display:block;font-size:14px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/bare_home/landing.scss
// module id = 562
// module chunks = 0